export default "__VITE_ASSET__d81a28ac__"